import { Select } from 'antd';
import { observer } from 'mobx-react';
import { useMemo } from 'react';
import { useCartogramStore } from '../context';
import { CartogramValueColumnName } from '../types';

import './style.scss';

export const CartogramFilters = observer(function CartogramFilters() {
  const { filters } = useCartogramStore();

  const selectableColumnsOptions = useMemo(() => {
    const columnNames = filters.tableColumns.map(
      ({ column_name }) => column_name,
    );

    return Object.entries(CartogramValueColumnName)
      .map(([value, label]) => ({ value, label }))
      .filter(({ value }) => columnNames?.includes(value));
  }, [filters.tableColumns]);

  return (
    <div className="cartogram__filters">
      <Select
        loading={filters.isCartogramsLoading}
        placeholder="Выберите картограмму"
        value={filters.cartogram}
        onChange={filters.setCartogram}
        options={filters.cartograms.map((cartogram) => ({
          value: cartogram.id,
          label: cartogram.description,
        }))}
      />

      <Select
        loading={filters.isTableColumnsLoading}
        placeholder="Поле для расчета"
        value={filters.tableColumn}
        disabled={!filters.cartogram}
        onChange={filters.setTableColumn}
        options={selectableColumnsOptions}
      />

      <div className="cartogram__filters__errors">
        {filters.tableColumnsError && <span>{filters.tableColumnsError}</span>}
        {filters.cartogramsError && <span>{filters.cartogramsError}</span>}
      </div>
    </div>
  );
});
